import {
    AnonymousAuthenticationProvider,
    BaseBearerTokenAuthenticationProvider,
} from "@microsoft/kiota-abstractions";
import { FetchRequestAdapter } from "@microsoft/kiota-http-fetchlibrary";
import { createContentVaultApiClient } from "@/client/ContentVaultApiClient/contentVaultApiClient";
import { API_BASE_URL } from "@/env";
import { StaticAccessTokenProvider } from "./StaticAcccesTokenProvider";

export type ContentVaultApiClient = ReturnType<typeof createContentVaultApiClient>;

export function createAnonymousApiClient(): ContentVaultApiClient {
    const authProvider = new AnonymousAuthenticationProvider();
    const adapter = new FetchRequestAdapter(authProvider);
    adapter.baseUrl = API_BASE_URL;

    return createContentVaultApiClient(adapter);
}

export function createAuthenticatedApiClient(token: string): ContentVaultApiClient {
    const authProvider = new BaseBearerTokenAuthenticationProvider(
        new StaticAccessTokenProvider(token, new URL(API_BASE_URL).host)
    );
    const adapter = new FetchRequestAdapter(authProvider);
    adapter.baseUrl = API_BASE_URL;

    return createContentVaultApiClient(adapter);
}
